export default "__VITE_ASSET__BMuiFr$s__"